import { useState, useEffect } from 'react';

/** Returns current time updated every `intervalMs` (default 250). */
export function useNow(intervalMs = 250) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
